import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { btn } from "@/components/common/btn";
import { money } from "@/lib/format";

// Amber "Review" tag: the Equipment Library cost basis moved since this line was priced.
export function LibraryReviewTag({ changes, onApply, onDismiss, testId }) {
  if (!changes?.length) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} title="Library cost changed — click to review"
          className="shrink-0 rounded bg-amber-100 px-1.5 py-px text-[10px] font-semibold leading-4 text-amber-700 hover:bg-amber-200" data-testid={testId}>
          Review
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 p-3 text-xs" onClick={(e) => e.stopPropagation()}>
        <div className="mb-2 font-semibold text-slate-800">Library cost changed</div>
        <ul className="mb-3 space-y-1">
          {changes.map((c) => (
            <li key={c.key} className="flex justify-between gap-3 text-slate-600">
              <span>{c.label}</span>
              <span className="tabular-nums">
                {c.money ? money(c.from) : c.from} <span className="text-slate-400">→</span> <span className="font-semibold text-slate-900">{c.money ? money(c.to) : c.to}</span>
              </span>
            </li>
          ))}
        </ul>
        <div className="flex gap-2">
          <button type="button" className={btn("write")} onClick={onApply} data-testid={testId ? `${testId}-apply` : undefined}>Apply New Cost</button>
          <button type="button" className={btn("nav")} onClick={onDismiss} data-testid={testId ? `${testId}-dismiss` : undefined}>Keep Mine</button>
        </div>
        <p className="mt-2 text-[11px] text-slate-400">The proposal keeps its price until you apply. Once Won the tag no longer shows.</p>
      </PopoverContent>
    </Popover>
  );
}
